import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import InputTextField from '../../../../../component/input/inputTextField';
import FilterSelect from '../../../../../component/select/filterSelect';
import { MenuItem, Typography } from '@mui/material';

import { PlanApi, createPlanType } from '../../../../../api/plan/plan.api';
import { ButtonContained } from '../../../../../component/mui-custom/MuiCustom';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../component/notification/swal';

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    idPlan: number;
}

const EditPlan: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [plan, setPlan] = useState<createPlanType>({
        planName: "",
        planNo: "",
        planStatus: t("STATUS.ACTIVE")
    })

    const handleGetPlan = async () => {
        dispatch(setLoading())
        await PlanApi.getDetailPlan(props.idPlan)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { planName, planNo, planStatus } = res.data?.result
                    setPlan((prev) => ({ ...prev, planName: planName, planNo: planNo, planStatus: planStatus }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await PlanApi.updatePlan(props.idPlan, plan)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
            .finally(() => {
                props.fetchData()
                props.toggleModal()
            })
    }

    useEffect(() => {
        handleGetPlan()
    }, [])

    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setPlan((prev) => ({ ...prev, planNo: e.target.value }))}
                        value={plan.planNo}
                        heading='ลำดับแผนงาน'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setPlan((prev) => ({ ...prev, planName: e.target.value }))}
                        value={plan.planName}
                        heading='ชื่อแผนงาน'
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะ")}
                        renderValue={() => plan.planStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={plan.planStatus}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setPlan((prev) => ({ ...prev, planStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default EditPlan